/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import React from "react"
import { Flex } from "@theme-ui/components"

import PageLink from "./page-link"
import Text from "./text"

import { renderLineBreak } from "../helpers"

import shareLink from "../images/facebook.svg"
import twitterLogo from "../images/twitter.svg"
import copyLinkImg from "../images/copy-link.svg"

import { useIsClient } from "../hooks/use-is-client"
import Row from "./row"
import Column from "./column"

const SpecificationsOverview = ({
  pathname,
  title,
  displayTitle,
  tableContent,
  titleStyle,
  ...restProps
}) => {
  const [ready, setReady] = React.useState(false)
  const [isMobile, setWidth] =  React.useState(false);

  const setWindowWidth = () => {
    setWidth((window.innerWidth <= 768));
     
  }

  const checkIfWindow = () => {
    if (typeof window !== "undefined") {
      window.addEventListener("orientationchange", setWindowWidth)
      return typeof window !== "undefined"
    }
    return typeof window !== "undefined"
  }
  
  React.useEffect(() => {
    if (checkIfWindow) {
      window.addEventListener('resize', setWidth((window.innerWidth <= 768)));
      setReady(true);
    }
  }, []);
  
  const isClient = useIsClient()
  const socialLinkList = [
    {
      id: "twitter-link",
      alt: "Link to Twitter",
      href: `https://twitter.com/intent/tweet?text=${title}&url=${encodeURI(
        `${(isClient && window.location.href) ||
          `https://www.plantprefab.com${pathname}`}`
      )}`,
      src: twitterLogo,
    },
    {
      id: "share-link",
      alt: "Share",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
        `${(isClient && window.location.href) ||
          `https://www.plantprefab.com${pathname}`}`
      )}`,
      src: shareLink,
    },
    {
      id: "copy-link",
      alt: "Copy Link",
      messageOnClick: "Copied to clipboard",
      action: () => {
        const text = window.location.href
        var textArea = document.createElement("textarea")
        textArea.value = text

        // Avoid scrolling to bottom
        textArea.style.top = "0"
        textArea.style.left = "0"
        textArea.style.position = "fixed"

        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        document.execCommand("copy")
        document.body.removeChild(textArea)
      },
      src: copyLinkImg,
    },
  ]
  const styleList = {
    socialLinkList: {
      item: {
        flexShrink: 0,
        m: 0,
        mr: 3,
        ":last-child": { mr: 0 },
      },
    },
  }
  const [showMessage, setShowMessage] = React.useState({})
  return (
    <Flex
      sx={{
        flexDirection: "column",
        pt: theme => theme.spacing.vertical.sm,
        pb: theme => [
          theme.spacing.vertical.sm,
          theme.spacing.vertical.sm,
          theme.spacing.vertical.md,
        ],
      }}
      {...restProps}
    >
      <Text
        customStyle={{
          fontSize: [6, 6, 7],
          maxWidth: ["none", "none", 576],
          ...titleStyle,
        }}
        type="h1"
      >
        {displayTitle ? renderLineBreak(displayTitle) : title}
      </Text>
      <div
        sx={{
          justifyContent: "space-between",
          alignItems: "flex-end",
          display: ["block", "block", "flex"],
          mt: [
            theme => theme.spacing.vertical.sm,
            theme => theme.spacing.vertical.sm,
            theme => theme.spacing.vertical.lg,
          ],
        }}
      >
        {tableContent && tableContent.length && (
          <Row 
          customStyle={{px: [0, 0, null, null] , width : (isMobile) ? "" : "100%" }}
          >
            {tableContent.map((contentData, index) =>
              contentData.bodyText ? (
                <Column
                  size={(isMobile) ? [6, 6, 6, 6] : []}
                  // customStyle={{
                  //   mb: theme => [
                  //     theme.spacing.vertical.sm,
                  //     theme.spacing.vertical.sm,
                  //     0,
                  //   ],
                  //   mr: [0, 0, 5],
                  //   whiteSpace: "nowrap",
                  // }}
                  key={index}
                  maxWidth={  (isMobile) ? "" : (index === 0) ? "250px" : "150px" }
                  margin={(isMobile)  ? "5% 0" :""}
                >
                  {contentData.headingText && (
                    <Text customStyle={{ textTransform: "uppercase" }}>
                      {contentData.headingText}
                    </Text>
                  )}
                  <Text customStyle={{ fontWeight: "bold" }}>
                    {contentData.bodyText}
                  </Text>
                </Column>
              ) : null
            )}
          </Row>
        )}
        <ul
          sx={{
            alignItems: "center",
            display: "flex",
            listStyle: "none",
            m: 0,
            ml: 0,
            margin:(isMobile) ? "5% 0" : ""
          }}
        >
          <li sx={{ ...styleList.socialLinkList.item, mr: 3 }}>
            <Text customStyle={{ textTransform: "uppercase" }}>Share:</Text>
          </li>
          {socialLinkList.map((link, index) => (
            <li
              sx={{
                position: "relative",
                ...styleList.socialLinkList.item,
                display: "flex",
                ...(link.messageOnClick && {
                  "::after": {
                    content: `'${link.messageOnClick}'`,
                    position: "absolute",
                    top: showMessage[index]
                      ? ["-2px", "-2px", 28]
                      : ["-2px", "-2px", 20],
                    right: ["unset", "unset", 0],
                    left: showMessage[index]
                      ? [28, 28, "unset"]
                      : [24, 24, "unset"],
                    fontSize: 16,
                    whiteSpace: "nowrap",
                    fontFamily: "body",
                    color: "#777",
                    transition: "0.5s",
                    opacity: showMessage[index] ? "1" : "0",
                    pointerEvents: "none",
                  },
                }),
              }}
              key={link.id}
            >
              <PageLink
                customStyle={{ display: "block", pr: 0, cursor: "pointer" }}
                link={link.href}
                onClick={() => {
                  setShowMessage({ ...showMessage, [index]: true })
                  setTimeout(
                    () => setShowMessage({ ...showMessage, [index]: false }),
                    2500
                  )
                  link.action()
                }}
              >
                <img
                  sx={{ display: "block", width: 20 }}
                  src={link.src}
                  alt={link.alt}
                />
              </PageLink>
            </li>
          ))}
        </ul>
      </div>
    </Flex>
  )
}

SpecificationsOverview.propTypes = {
  pathname: PropTypes.string,
  tableContent: PropTypes.arrayOf(
    PropTypes.shape({
      bodyText: PropTypes.string,
      headingText: PropTypes.string,
    })
  ),
  title: PropTypes.string,
}

export default SpecificationsOverview
